module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_6000.6a42ea3c.png";